import {
  WS_CONNECT,
  WS_DISCONNECT,
  WS_REQUEST,
  WEB_SOCKET_CONNECTION_ERROR,
} from '../containers/constants'
import {
  wsConnected,
  updateCartStatus,
  wsDisconnected,
} from '../containers/actionCreators'
import stompSocketService from '../services/stompSocketService'

function webSocketMiddleware() {
  let socket = null
  let endpoint = ''
  const onSocketConnected = callback => msg => {
    console.log('Socket connection established. ', msg)
    callback()
  }
  const onSocketDisconnected = callback => msg => {
    console.log('Socket disconnected. ', msg)
    callback()
  }

  return store => next => action => { // eslint-disable-line consistent-return
    const {
      params,
      type,
      payload,
      payload: sessionId,
    } = action
    switch (type) {
      case WS_CONNECT:
        try {
          endpoint = `/topic/session/${sessionId}`
          const curriedFunc = onSocketConnected(() => {
            store.dispatch(wsConnected())
            socket.subscribe(endpoint, e => {
              const message = JSON.parse(e.body)
              store.dispatch(updateCartStatus(message))
            })
            console.log(socket)
          })
          const errorHandlerFunc = onSocketDisconnected(err => store.dispatch(wsDisconnected({ code: WEB_SOCKET_CONNECTION_ERROR, ...err })))
          socket = stompSocketService(store.dispatch, curriedFunc, errorHandlerFunc)
          window.globalStomp = socket;
          window.parent.postMessage(
            {
              type: 'webSocketEstablished',
              payload: { websocketId: sessionId },
            },
            '*'
          )
          // socket.ws.onopen()
        } catch (e) {
          console.error('An issue occured within websocket setup, ', e)
        }
        break

      case WS_DISCONNECT:
        if (socket) {
          socket.disconnect(() => {
            store.dispatch(wsDisconnected())
          })
        }
        socket = null
        break

      case WS_REQUEST:
        if (socket) {
          socket.send(endpoint, {}, JSON.stringify(payload))
        }
        break
      default:
        return next(action)
    }
  }
}
const socketMiddleware = webSocketMiddleware()
export default socketMiddleware



// WEBPACK FOOTER //
// ./src/components/websocket.js